import React from 'react';
import { VirtualizedMessageList, useChannelStateContext } from 'stream-chat-react';
import CustomMessage from '../CustomMessage';
import EmptyView from '../EmptyView';
import { IChatChannel } from '../../interfaces/IChatChannel';
import { UserRole } from '../../types/UserRole';
import useFollowOutput from '../../hooks/useFollowOutput';

interface IMessageListWrapper {
    chatChannel: IChatChannel;
    userRole: UserRole;
}

const MessageListWrapper: React.FC<IMessageListWrapper> = ({ chatChannel, userRole }) => {
    const { messages } = useChannelStateContext();
    const [followOutput, onToggleInteraction] = useFollowOutput();

    if (!messages.length) {
        return <EmptyView />;
    }

    return (
        <VirtualizedMessageList
            Message={() => (
                <CustomMessage
                    chatChannel={chatChannel}
                    userRole={userRole}
                    onTogglePopover={onToggleInteraction}
                />
            )}
            disableDateSeparator
            additionalVirtuosoProps={{
                followOutput,
            }}
        />
    );
};

export default MessageListWrapper;
